import { IntegrationSettingsValues } from '@trnsact/trnsact-shared-types';
import { IntegrationSettingsEntry, IntegrationSettingsAccountLevelForm } from '../types';

export const getAccountIntegrationSettingsTableData = (
  account: { id: string; name: string },
  integrationSettingsValues: IntegrationSettingsValues
): IntegrationSettingsAccountLevelForm => ({
  accountId: account.id,
  accountName: account.name,
  integrationSettingsValuesId: integrationSettingsValues?.integrationSettingsValuesId || null,
  integrationSettingsValues: integrationSettingsValues
    ? {
        ...(integrationSettingsValues.integrationSettingsValues as unknown as IntegrationSettingsEntry),
      }
    : null,
});
